import React, { Fragment } from "react";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SidebarNavigation from "../components/layout/sidebar-navigation";
import TopBarNavigation from "../components/layout/top-bar";
import { CssBaseline } from "@mui/material";
import Plan from "./plan";
import { borderBottom } from "@mui/system";
import Seats from "./seats";
import Billing from "./billing";
import useHttp from "../hooks/use-http";
import Profile from "./profile";



const Account = () => {
  const {
    isLoading,
    isError,
    message,
    sendRequest: getBillingDetails,
  } = useHttp();

  const [billingListsState, setBillingListsState] = React.useState([]);


  const getBillingDetailsResponse = (res: any) => {
    if (res.data) {
      setBillingListsState(res.data.invoice);
    }
  };

  React.useEffect(() => {
    getBillingDetails(

      {
        URL: "/api/billing",
        method: "GET",
        header: {
          "Content-Type": "application/json",
        },
      },
      getBillingDetailsResponse
    );
  }, []);


  return (
    <Box ml={2} mr={2} mt={9} sx={{ width: "100%" }}>
      <Accordion defaultExpanded={true}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{
            "&.Mui-expanded": {
              minHeight: "55px",
              borderBottom: "1px solid #E8E8EA",
              marginBottom: "15px",
            },
          }}
        >
          <Typography variant="subtitle1">Plan</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Plan />
        </AccordionDetails>
      </Accordion>
      <Accordion sx={{ mt: 1 }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
          sx={{
            "&.Mui-expanded": {
              minHeight: "55px",
              borderBottom: "1px solid #E8E8EA",
              marginBottom: "15px",
            },
          }}
        >
          <Typography variant="subtitle1">Billing</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Billing billingLists={billingListsState} />
        </AccordionDetails>
      </Accordion>
      <Accordion sx={{ mt: 1 }}  >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
          sx={{
            "&.Mui-expanded": {
              minHeight: "55px",
              borderBottom: "1px solid #E8E8EA",
              marginBottom: "15px",
            },
          }}
        >
          <Typography variant="subtitle1">Profile</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Profile />
        </AccordionDetails>
      </Accordion>
      <Accordion sx={{ mt: 1 }} TransitionProps={{ unmountOnExit: true }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4a-content"
          id="panel4a-header"
          sx={{
            "&.Mui-expanded": {
              minHeight: "55px",
              borderBottom: "1px solid #E8E8EA",
              marginBottom: "15px",
            },
          }}
        >
          <Typography variant="subtitle1">Users</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Seats />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default Account;
